module.exports = __webpack_public_path__ + "img/slider_17.954c045f.jpg";